import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transformation-cobol-settings',
  templateUrl: './transformation-cobol-settings.component.html',
  styleUrls: ['./transformation-cobol-settings.component.scss']
})
export class TransformationCobolSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
